import { render, staticRenderFns } from "./ZendeskAccountModal.vue?vue&type=template&id=bed98c90&"
import script from "./ZendeskAccountModal.vue?vue&type=script&lang=js&"
export * from "./ZendeskAccountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ZendeskAccountModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/providers/ZendeskAccountModal.vue
// module id = 2381
// module chunks = 1